export default __webpack_public_path__ + "static/media/Mahalaxmi.f63a3b75.png";